import React from "react";
import { useAuth } from "../../context/AuthContext";
import LockedFeature from "./LockedFeature";

/**
 * Route-level gate: renders children when the current member has the
 * given hub-access flag, otherwise a full-page locked screen.
 *
 * Admins always pass through — the backend sets can_access_* = true for
 * role=="admin" in public_user(), so no explicit role check is needed.
 */
export default function HubAccessGate({
  feature,        // "ai_office" | "employz"
  featureName,
  description,
  testid,
  children,
}) {
  const { user } = useAuth();
  const flagKey = feature === "ai_office" ? "can_access_ai_office" : "can_access_employz";
  const allowed = !!user?.[flagKey];
  if (!allowed) {
    return (
      <LockedFeature
        featureName={featureName}
        description={description}
        testid={testid || `${feature}-locked-screen`}
      />
    );
  }
  return children;
}
